/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Package, Package$inboundSchema } from "./package.js";
import {
  PackageVersion,
  PackageVersion$inboundSchema,
} from "./packageversion.js";

export type ListVersionsResult = {
  package: Package;
  versions: Array<PackageVersion>;
};

/** @internal */
export const ListVersionsResult$inboundSchema: z.ZodMiniType<
  ListVersionsResult,
  unknown
> = z.object({
  package: Package$inboundSchema,
  versions: z.array(PackageVersion$inboundSchema),
});

export function listVersionsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListVersionsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListVersionsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListVersionsResult' from JSON`,
  );
}
